import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Načítať zákazku',
    confirmMessage: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Spustiť zákazku',
    confirmMessage: 'Potvrďte spustenie {recipeCode} na {assetDisplayName}.',
    confirmLabel: 'Spustiť {recipeCode}',
  },
  ABORT_JOB: {
    label: 'Prerušiť zákazku',
    confirmMessage: 'Naozaj chcete prerušiť zákazku {jobNo} ({recipeCode}) na {assetDisplayName}?',
    confirmLabel: 'Prerušiť {jobNo}',
  },
  RESUME_JOB: {
    label: 'Obnoviť zákazku',
    confirmMessage: 'Naozaj chcete obnoviť {recipeCode} na {assetDisplayName}?',
    confirmLabel: 'Obnoviť {recipeCode}',
  },
};

export default {
  button: buttonTranslations,
};
